import { chain } from '@leprecoins/effector';
import { notifications as mantineNotifications } from '@mantine/notifications';
import { createEffect, createEvent } from 'effector';

export type ShowNotificationPayload = Parameters<typeof mantineNotifications.show>[0];

export const showNotification = createEvent<ShowNotificationPayload>();

export const showSuccessNotification = createEvent<ShowNotificationPayload>();

export const showErrorNotification = createEvent<ShowNotificationPayload>();

export const showNotificationFx = createEffect<ShowNotificationPayload, string>((options) =>
	mantineNotifications.show(options),
);

export const showSuccessNotificationFx = createEffect<ShowNotificationPayload, string>((options) =>
	mantineNotifications.show({ ...options, variant: 'success' }),
);

export const showErrorNotificationFx = createEffect<ShowNotificationPayload, string>((options) =>
	mantineNotifications.show({ ...options, variant: 'error' }),
);

chain(showNotification, showNotificationFx);

chain(showSuccessNotification, showSuccessNotificationFx);

chain(showErrorNotification, showErrorNotificationFx);

export const notifications = {
	show: showNotification,
	showSuccess: showSuccessNotification,
	showError: showErrorNotification,
};
